import { FrameWorkGetSecundaryColorButton, FrameWorkHideAlert, FrameWorkMessageErrorAlert, FrameWorkMessageSuccessAlert, FrameWorkSimpleMessageState, FrameWorkVerifyEmail, OrdenExpressIsAdmin } from 'orden_express/frameWork/frameWork.js';
import { requestResetStateLogin, requestVerifiedUser } from 'orden_express/login/loginEpic';
import { requestResetStateOrder } from 'orden_express/orders/ordersEpic';
import { requestResetStateProducts } from 'orden_express/products/productsEpic';
import { requestResetStateReports } from 'orden_express/reports/reportsEpic';
import { requestResetStateRoutes } from 'orden_express/routes/routesEpic';
import { requestResetStateUsers } from 'orden_express/users/usersEpic';
import React from 'react';
import { connect } from 'react-redux';
import { Button, Card, CardBody, CardFooter, CardHeader, Col, Container, Form, FormGroup, Input, InputGroup, InputGroupAddon, InputGroupText, Label, Row } from 'reactstrap';
import { bindActionCreators } from 'redux';


class Login extends React.Component {

  inicialState = () => {
    return {
      password: '',
      user: '',
      getPasswordToEmail: false,
      email: '',
      alert: '',
      requestPassword: false,
      userEmail: '',
    };
  }

  constructor(props) {
    super(props);

    this.props.requestResetStateLogin();
    this.props.requestResetStateOrder();
    this.props.requestResetStateProducts();
    this.props.requestResetStateReports();
    this.props.requestResetStateRoutes();
    this.props.requestResetStateUsers();

    this.state = this.inicialState();
  }

  componentDidUpdate = (prevProps) => {
    if (this.props.loginReducerState.responseVerifiedUser !== prevProps.loginReducerState.responseVerifiedUser) {
      this.processMessageState(this.props.loginReducerState.messageLogin);
    }
  }

  componentDidMount = () => {
    document.body.classList.toggle('login-page');
  }
  componentWillUnmount = () => {
    document.body.classList.toggle('login-page');
  }

  loginActionHandle = () => {
    if (this.state.user === undefined || this.state.user === null || this.state.user.trim() === '') {
      FrameWorkMessageErrorAlert(this, 'Falta el usuario :(', 'Ingrese el usuario...');
      return;
    }

    if (this.state.password === '' || this.state.password === null || this.state.password === undefined) {
      FrameWorkMessageErrorAlert(this, 'Falta la clave :(', 'Ingrese la clave...');
      return;
    }

    this.setState({ getPasswordToEmail: false });

    var dataForLogin = {
      identification: this.state.user,
      password: this.state.password,
      getPasswordToEmail: false,
    };
    this.props.requestVerifiedUser(dataForLogin);
    this.processMessageState(1);
  }

  handleUserChange = (e) => {
    this.setState({ user: e.target.value });
  }

  handlePasswordChange = (e) => {
    this.setState({ password: e.target.value });
  }

  handleUserEmail = (e) => {
    this.setState({ email: e.target.value });
  }

  toggleAlertDialog = () => {
    this.setState({
      alertDialog: null
    });
  }

  processMessageState = (pStateForMessage) => {
    switch (pStateForMessage) {
      case 1://procesando solicitud
        FrameWorkSimpleMessageState(this, 'Verificando', 'Su solicitud está en proceso ...');
        break;

      case 2:
        //FrameWorkMessageSuccessAlert(this, 'Correcto!', 'Los datos fueron correctamente almacenados', this.succesSaving, this.succesSaving);
        FrameWorkHideAlert(this);
        if (OrdenExpressIsAdmin(this)) {
          this.props.history.push('/admin/processOrders');
        } else {
          this.props.history.push('/client/makeOrder');
        }
        break;

      case 3:
        if (this.state.getPasswordToEmail === false) {
          FrameWorkMessageErrorAlert(this, 'Error :(', this.props.loginReducerState.responseVerifiedUser.message);
        }
        break;

      default:
        FrameWorkHideAlert(this);
        break;
    }
  }

  getPasswordRequest = () => {
    if (this.state.user.trim() === '' || this.state.user === null || this.state.user === undefined) {
      FrameWorkMessageErrorAlert(this, 'Falta el usuario :(', 'Ingrese el usuario...');
      return;
    }
    var infoEmail = FrameWorkVerifyEmail(this.state.email); //FrameWorkChange(this, this.state.user.email, 'userEmail', 'email');
    if (!infoEmail) {
      FrameWorkMessageErrorAlert(this, 'Falta el correo :(', 'Ingrese el correo registrado...');
      return;
    }
    this.setState({ getPasswordToEmail: true });
    var dataForLogin = {
      identification: this.state.user,
      password: '',
      email: this.state.email.trim(),
      getPasswordToEmail: true,
    };

    this.props.requestVerifiedUser(dataForLogin);
    FrameWorkMessageSuccessAlert(this, 'Solicitud en proceso', 'Si la información es correcta y está activo en el sistema, sus datos de acceso serán enviados a su correo electrónico.', this.endOfRequestEmailPassword, this.endOfRequestEmailPassword);
  }

  endOfRequestEmailPassword = () => {
    var localState = this.inicialState();
    localState.getPasswordToEmail = true;//para evitar mensajes cuando responde el servidor
    this.setState(localState);
  }

  render() {
    return (
      <div className='login-page'>
        {this.state.alert}
        <Container>
          <Row>
            <Col className='ml-auto mr-auto' lg='4' md='6'>
              <Form action='' className='form' method=''>
                <Card className='card-login'>
                  <CardHeader>
                    <CardHeader>
                      <h3 className='header text-center'>Ingreso</h3>
                    </CardHeader>
                  </CardHeader>
                  <CardBody>

                    <InputGroup>
                      <InputGroupAddon addonType='prepend'>
                        <InputGroupText>
                          <i className='nc-icon nc-single-02' />
                        </InputGroupText>
                      </InputGroupAddon>
                      <Input placeholder='Usuario...'
                        type='text'
                        name='user'
                        value={this.state.user}
                        onChange={this.handleUserChange.bind(this)} />
                    </InputGroup>
                    <InputGroup>
                      <InputGroupAddon addonType='prepend'>
                        <InputGroupText
                          hidden={this.state.requestPassword}
                        >
                          <i className='nc-icon nc-key-25' />
                        </InputGroupText>
                      </InputGroupAddon>
                      <Input
                        placeholder='Clave...'
                        type='password'
                        autoComplete='off'
                        name='password'
                        hidden={this.state.requestPassword}
                        value={this.state.password}
                        onChange={this.handlePasswordChange.bind(this)}
                        onKeyDown={event => {
                          if (event.keyCode === 13) {
                            this.loginActionHandle();
                          }
                        }}
                      />
                    </InputGroup>

                    <InputGroup>
                      <InputGroupAddon addonType='prepend'>
                        <InputGroupText
                          hidden={!this.state.requestPassword}
                        >
                          <i className='nc-icon nc-email-85' />
                        </InputGroupText>
                      </InputGroupAddon>
                      <Input placeholder='Correo electrónico...'
                        type='email'
                        name='email'
                        hidden={!this.state.requestPassword}
                        value={this.state.email}
                        onChange={this.handleUserEmail.bind(this)} />
                    </InputGroup>
                    <FormGroup check className='mt-2'>
                      <Label check>
                        <Input
                          className='ml-1'
                          name='optionCheckboxes'
                          type='checkbox'
                          checked={this.state.requestPassword === true ? 1 : 0}
                          onChange={value => { this.setState({ requestPassword: !this.state.requestPassword }); }} />
                        <span className='form-check-sign' />
                        {this.state.requestPassword ? 'Recordar la clave' : '¿Olvido su clave?'}
                      </Label>
                    </FormGroup>
                    <br />
                  </CardBody>
                  <CardFooter>
                    <Button
                      block
                      className='btn-round mb-3'
                      color='warning'
                      hidden={this.state.requestPassword}
                      onClick={(e) => {
                        this.loginActionHandle();
                      }
                      }
                    >
                      Ingresar
                    </Button>
                    <Button
                      block
                      className='btn-round mb-3'
                      color={FrameWorkGetSecundaryColorButton()}
                      disabled={!this.state.requestPassword}
                      hidden={!this.state.requestPassword}
                      onClick={(e) => {
                        this.getPasswordRequest();
                      }
                      }
                    >
                      {'Recordar Clave'}
                    </Button>
                  </CardFooter>
                </Card>
              </Form>
            </Col>
          </Row>
        </Container>
        <div
          className='full-page-background'
          style={{
            backgroundImage: `url(${require('assets/img/fabio-mangione.jpg')})`
          }}
        />
      </div>
    );
  }
}

const mapStateToProps = state => {
  return {
    userReducerState: state.userReducerState,
    productsReducerState: state.productsReducerState,
    ordersReducerState: state.ordersReducerState,
    routesReducerState: state.routesReducerState,
    reportsReducerState: state.reportsReducerState,
    loginReducerState: state.loginReducerState,
  };
};

const mapDispatchToProps = dispatch => {
  return {
    requestResetStateLogin: () => bindActionCreators(dispatch(requestResetStateLogin()), dispatch),
    requestResetStateOrder: () => bindActionCreators(dispatch(requestResetStateOrder()), dispatch),
    requestResetStateProducts: () => bindActionCreators(dispatch(requestResetStateProducts()), dispatch),
    requestResetStateReports: () => bindActionCreators(dispatch(requestResetStateReports()), dispatch),
    requestResetStateRoutes: () => bindActionCreators(dispatch(requestResetStateRoutes()), dispatch),
    requestResetStateUsers: () => bindActionCreators(dispatch(requestResetStateUsers()), dispatch),

    requestVerifiedUser: (dataUserLoging) => bindActionCreators(dispatch(requestVerifiedUser(dataUserLoging)), dispatch),
  };
};

export default connect(mapStateToProps, mapDispatchToProps)(Login);